import { Components, Theme } from '@mui/material/styles';

import * as Colors from 'src/theme/colors';

const MuiAutocomplete: Components<Theme>['MuiAutocomplete'] = {
  styleOverrides: {
    // MUI v5 ships much heavier defaults than v4 (`padding: 9px` on the
    // OutlinedInput wrapper, `padding: 7.5px 4px 7.5px 5px` on the inner
    // `.MuiAutocomplete-input`, plus 39px / 65px right-padding for the
    // popup/clear icons). These collectively inflate the input past the
    // 30px height set by `BaseTextField`'s skinny variant. Override every
    // icon-state variant + the inner input so the cascade always lands on
    // our values regardless of which icons the consumer renders.
    root: {
      '&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root':
        {
          paddingRight: 14,
        },
      '&.MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input': {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
    inputRoot: {
      '&.MuiOutlinedInput-root': {
        padding: '0px 4.5px',
      },
    },
    paper: {
      margin: '4px 0px',
    },
    option: {
      minHeight: 'auto',
      padding: '6px 16px',
    },
    listbox: {
      '& .MuiAutocomplete-option': {
        '&.Mui-focused': {
          backgroundColor: Colors.HoverNonBorderBackground,
        },
        '&[aria-selected="true"]': {
          backgroundColor: 'transparent !important',
        },
      },
    },
  },
};

export default MuiAutocomplete;
